import { render, staticRenderFns } from "./EquipDisplay.vue?vue&type=template&id=131ac4e8&scoped=true"
import script from "./EquipDisplay.vue?vue&type=script&lang=js"
export * from "./EquipDisplay.vue?vue&type=script&lang=js"
import style0 from "./EquipDisplay.vue?vue&type=style&index=0&id=131ac4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ac4e8",
  null
  
)

export default component.exports